import { render, staticRenderFns } from "./Hotelpage.vue?vue&type=template&id=4d4fbf1a&scoped=true&"
import script from "./Hotelpage.vue?vue&type=script&lang=js&"
export * from "./Hotelpage.vue?vue&type=script&lang=js&"
import style0 from "./Hotelpage.vue?vue&type=style&index=0&id=4d4fbf1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fbf1a",
  null
  
)

export default component.exports